/* ============================================================
   custom.js — Rebecca Zanetti store
   Hides the quick-view / add-to-cart hover icon on any product
   card whose title or URL indicates it's an eBook or Audiobook.
 
   Works on collection pages, search results, related products,
   and any dynamically loaded product grids.
   ============================================================ */
 
(function () {
  // Words that mark a product as an ebook or audiobook.
  // Add/remove entries here if the catalog changes.
  var HIDE_KEYWORDS = ['ebook', 'e-book', 'audiobook', 'audio book'];
 
  // Return true if this product card is an ebook or audiobook.
  function shouldHide(card) {
    // 1. Check the product title text inside the card.
    var titleEl = card.querySelector('.product-title');
    var title = titleEl ? titleEl.textContent.toLowerCase() : '';
 
    // 2. Check any product link href inside the card (covers
    //    cases where title text is hidden or abbreviated).
    var link = card.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href').toLowerCase() : '';
 
    var haystack = title + ' ' + href;
    for (var i = 0; i < HIDE_KEYWORDS.length; i++) {
      if (haystack.indexOf(HIDE_KEYWORDS[i]) !== -1) return true;
    }
    return false;
  }
 
  // Hide the quick-view icon inside a single card.
  function hideIcon(card) {
    var icons = card.querySelectorAll(
      '.quick-view-icon, .product-quickview, [data-quick-view]'
    );
    icons.forEach(function (el) {
      el.style.display = 'none';
    });
  }
 
  // Scan a subtree for matching cards and hide their icons.
  function processCards(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.product-card');
    cards.forEach(function (card) {
      if (shouldHide(card)) hideIcon(card);
    });
  }
 
  function init() {
    processCards();
 
    // Watch for product cards that get added later (infinite
    // scroll, collection filters, quick-view refreshes, etc.)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return; // element nodes only
          if (node.matches && node.matches('.product-card')) {
            if (shouldHide(node)) hideIcon(node);
          } else if (node.querySelector) {
            processCards(node);
          }
        });
      });
    });
 
    observer.observe(document.body, { childList: true, subtree: true });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


